<template>
<div class="container">
  <el-tabs  v-model="activeName2"   @tab-click="handleClick">
    <el-tab-pane  :label="item.label" :name="item.value" v-for="(item,index) in configTypes" :key="index" >
      <el-table
          :data="tableData"
          style="width: 100%">
        <el-table-column
            prop="id"
            label="ID"
            width="180">
        </el-table-column>
        <el-table-column
            label="配置类型"
            width="200">
          <template #default="scope">
            <span v-if="scope.row.edit && (scope.row.id != null)">
            <el-select  placeholder="配置类型" v-model.number="scope.row.value_type">
              <el-option
                  v-for="item in configTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)"></el-option>
            </el-select>
            </span>
            <span v-else-if="scope.row.id === null">
            <el-select  placeholder="配置类型" v-model.number="query.value_type" disabled="true">
              <el-option
                  v-for="item in configTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)"></el-option>
            </el-select>
            </span>
            <span v-else>{{configTypeMap.get(scope.row.value_type)}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="内容" show-overflow-tooltip>
          <template #default="scope">
            <span v-if="scope.row.edit">
            <el-input placeholder="请输入内容" v-model="scope.row.value"></el-input>
              </span>
            <span v-else>{{scope.row.value}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="是否有效"
            align="center"
            width="100">
          <template #default="scope">
            <el-button  :disabled="scope.row.id <= 0" type="text" :style="'color:'+[!scope.row.is_validate?'red':'']"
                        @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="230">
          <template #default="scope">
            <el-button type="text" v-if="!scope.row.edit" icon="el-icon-edit"  @click="handleEdit(scope.row, scope.$index)">编辑</el-button>
            <el-button type="text" v-else-if ="scope.row.id > 0" @click="handleCancel(scope.row, scope.$index)">取消</el-button>
            <el-button type="text" @click="handleSave(scope.row, scope.$index)" >保存</el-button>

            <el-popconfirm v-if="scope.row.id > 0" title="删除后不可恢复，确定删除吗" @confirm="removeConfig(scope.row.id,scope.$index)">
              <template #reference>
                <el-button type="text" icon="el-icon-delete" style="color:red;">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>

</div>
</template>

<script>


import {addConfig, deleteConfig, editConfig, getConfigList, getConfigType, setIs_validate} from "@/api/config";

export default {
  name:'setType',
  created() {
    this.getConfigType()
    this.getData()
  },
  data(){
    return{
      activeName2: 1,
      isShow:true,
      editIndex: -1,
      addFrom:{
        value_type:'',
        value:'',
        is_validate:null
      },
      configTypes:[],
      query:{
        value_type:1
      },
      configTypeMap: new Map(),
      tableData:[],
      rules: {
        value_type: [{required: true, message: '请输入名称', trigger: 'change'}],
        value: [{required: true, message: '请输入内容', trigger: 'blur'}],
      },
      is_validateOptions:[
        {
          value:'1',
          label:'有效'
        },
        {
          value:'0',
          label:'无效'
        }
      ],
      defaultValue: 1,
    }
  },
  methods:{
    getData(){
      getConfigList(this.query).then(res=>{
        this.tableData = JSON.parse(JSON.stringify(res))
        this.tableData.push({id:null, is_validate: true, edit:true})
      })
    },
    getConfigType(){
      getConfigType().then(res=>{
        this.configTypes = res
        res.forEach(item => {
          this.configTypeMap.set(item.value, item.label)
        })
      })
    },
    handleEdit(row, index){
      if (this.editIndex > -1) {
        this.tableData[this.editIndex].edit = false
      }
      row.edit = true
      this.editIndex = index
    },

    handleCancel(row, index) {
      row.edit = false
      this.editIndex = index
    },

    handleSave(row, index){
      row.value_type = this.query.value_type
      if (row.value_type === undefined || row.value_type === null || row.value_type <= 0) {
        this.$message.error('请选择类型！')
        return
      }

      if (row.value === undefined || row.value === null || row.value ==="") {
        this.$message.error('请输入内容！')
        return
      }

      if (row.id > 0) {
        editConfig(row,row.id).then(res=>{
          if(res === true){
            this.$message.success('修改成功！')
            this.getData()
          }
        })
      } else {
        addConfig(row).then(res=>{
          if(res){
            this.$message.success('添加成功！')
            this.tableData[index].id=res.id
            this.tableData[index].edit=false
            this.tableData.push({id:null, is_validate: true, edit:true})
          }
        })
      }

    },
    removeConfig(id,index){
      deleteConfig(id).then(res=>{
        if(res === true){
          this.$message.success('删除成功！')
          this.tableData.splice(index,1)
        }
      })
    },
    setIsvalidate(index,id,is_validate){
      setIs_validate(id,is_validate).then(res=>{
        if(res){
          this.$message.success('保存成功')
          this.tableData[index].is_validate = is_validate
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    handleClick(tab,e){
      this.query.value_type = tab.paneName
      this.getData()
    }
  }
}
</script>

<style scoped>
/deep/.el-tabs__item{
  width: 130px !important;
  text-align: center;
}
</style>